import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { Resource } from "./coreResource";
import { StorageService } from "./helpers/storage-Service";
import { CreditCardDirective } from "./directives/credit-card.directive";
import { LoadingComponent } from "./loading/loading.component";
import { ModalComponent } from "./modal/modal.component";

@NgModule({
    declarations: [CreditCardDirective, LoadingComponent, ModalComponent],
    exports: [LoadingComponent, ModalComponent],
    imports: [CommonModule],
    providers: [Resource, StorageService, provideHttpClient(withInterceptorsFromDi())]
})
export class CoreModule { }
